import Randomizer from "../../../../src/docs/components/randomizer";
import ClientRandomizer from "../../../../src/docs/components/clientrandomizer";
import MillsCard from "../../../../src/docs/components/millscard";
import Hendricks from "../../../../src/docs/assets/profiles/hendricks.jpg";
import Habersham from "../../../../src/docs/assets/profiles/habersham.jpg";
import White from "../../../../src/docs/assets/profiles/white.jpg";
import Thompson from "../../../../src/docs/assets/profiles/thompson.jpg";
import Ludwig from "../../../../src/docs/assets/profiles/ludwig.jpg";
import Pedersen from "../../../../src/docs/assets/profiles/pedersen.jpg";
import Clayton from "../../../../src/docs/assets/profiles/clayton.jpg";
import Ndou from "../../../../src/docs/assets/profiles/ndou.jpg";
import Otero from "../../../../src/docs/assets/profiles/otero.jpg";
import Tuutau from "../../../../src/docs/assets/profiles/tuutau.jpg";
import Martin from "../../../../src/docs/assets/profiles/martin.jpg";
import Lee from "../../../../src/docs/assets/profiles/lee.jpg";
import Rodriguez from "../../../../src/docs/assets/profiles/rodriguez.jpg";
import Colaneri from "../../../../src/docs/assets/profiles/colaneri.jpg";
import Havey from "../../../../src/docs/assets/profiles/havey.jpg";
import McCoy from "../../../../src/docs/assets/profiles/mccoy.jpg";
import Kemp from "../../../../src/docs/assets/profiles/kemp.jpg";
import Allred from "../../../../src/docs/assets/profiles/allred.jpg";
import * as React from 'react';
export default {
  Randomizer,
  ClientRandomizer,
  MillsCard,
  Hendricks,
  Habersham,
  White,
  Thompson,
  Ludwig,
  Pedersen,
  Clayton,
  Ndou,
  Otero,
  Tuutau,
  Martin,
  Lee,
  Rodriguez,
  Colaneri,
  Havey,
  McCoy,
  Kemp,
  Allred,
  React
};